import { gql } from "@apollo/client";

export const GET_SUB_ADMINS = gql`
  query GetSubAdmins {
    user(
      where: {
        u_deleted_at: { _is_null: true }
        _or: [{ u_role: { _eq: "sub_admin" } }, { u_allowed_roles: { _contains: ["sub_admin"] } }]
      }
      order_by: { u_created_at: desc }
    ) {
      u_id
      u_first_name
      u_last_name
      u_email_id
      u_phone_number
      u_country_code
      u_is_active
      u_delete_requested
      u_created_at
    }
  }
`;

export const UPDATE_SUB_ADMIN = gql`
  mutation UpdateSubAdmin($userId: uuid!, $input: user_set_input!) {
    update_user(where: { u_id: { _eq: $userId } }, _set: $input) {
      affected_rows
    }
  }
`;
